import { render } from "./ImportTable.vue?vue&type=template&id=f607385a"
import script from "./ImportTable.vue?vue&type=script&lang=js"
export * from "./ImportTable.vue?vue&type=script&lang=js"

import "./ImportTable.vue?vue&type=style&index=0&id=f607385a&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__